module.exports = __webpack_public_path__ + "static/media/PSHSA_Logo.e89bb925.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/PSHSA_Logo.svg
// module id = 386
// module chunks = 0